import React from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";

const PartnerLinkImage = ({ nameSEO, partnerImage, partnerName }) => {
  return (
    <>
      {nameSEO != null ? (
        <Link to={`/partners/${nameSEO}`}>
          {partnerImage ? (
            <img
              className="products__result-partner-image"
              src={partnerImage}
              alt={partnerName}
            />
          ) : (
            <span className="products__result-partner-name">{partnerName}</span>
          )}
        </Link>
      ) : (
        <>
          {partnerImage ? (
            <img
              className="products__result-partner-image"
              src={partnerImage}
              alt={partnerName}
            />
          ) : (
            <span className="products__result-partner-name">{partnerName}</span>
          )}
        </>
      )}
    </>
  );
};

PartnerLinkImage.propTypes = {
  nameSEO: PropTypes.string,
  partnerImage: PropTypes.string,
  partnerName: PropTypes.string
};

PartnerLinkImage.defaultProps = {
  nameSEO: null,
  partnerImage: null,
  partnerName: null
};

export default PartnerLinkImage;
